import React, {Component} from "react";
import {connect} from "react-redux";
import {requestAddCreditCard, requestChangeCreditCard} from "../../actions/AccountApiActions";
import CreditCardPaymentMethodV2 from "./CreditCardPaymentMethodV2";
import TaskIcon from "./TaskIcon";

class SelectPaymentMethodV2 extends Component {

  handleAddCard() {
    this.props.requestAddCreditCard(this.props.accountId);
  }

  handleChangeCard() {
    this.props.requestChangeCreditCard(this.props.accountId);
  }

  render() {
    return (
      <div className="SelectPaymentMethod section">
        {this.renderCreditCardMethod()}
        {this.renderPaymentTermsMethod()}
      </div>
    )
  }

  renderCreditCardMethod() {
    if (this.props.paymentMethod !== "credit_card") return null;
    return (
      <React.Fragment>
        <TaskIcon nr="2" completed={this.props.defaultPaymentMethod} />
        <div className="title">Review Billing Details</div>
        <div className="content">
          <p className="helptext">Please note that billing details are connected to your account, and will be used for any future transactions.</p>
          <CreditCardPaymentMethodV2
            defaultPaymentMethod={this.props.defaultPaymentMethod}
            onAddCard={this.handleAddCard.bind(this)}
            onChangeCard={this.handleChangeCard.bind(this)} />
        </div>
      </React.Fragment>
    )
  }

  renderPaymentTermsMethod() {
    if (this.props.paymentMethod !== "payment_terms") return null;
    return (
      <React.Fragment>
        <TaskIcon nr="2" completed={true} />
        <div className="title">Review Billing Details</div>
        <div className="content">
          <p className="helptext">You account has payment terms of {this.props.paymentTermsDays} days.</p>
        </div>
      </React.Fragment>
    )    
  }
}

export default connect(null, {
  requestChangeCreditCard, 
  requestAddCreditCard,
  })(SelectPaymentMethodV2);